import styled, { injectGlobal, css } from 'styled-components';
import theme from '../../config/theme';

injectGlobal`
  html {
    font-size: 100%;
  }

  body {
    font-family: ${theme.base.fontFamily};
    font-size: ${theme.base.fontSize};
    line-height: ${theme.base.lineHeight};
    margin: 0;
    padding: 0;
  }
`;

export const Wrapper = styled.section`
  margin-top: ${p => (p.makeSpaceForNotificationBar ? '90px' : '60px')};

  @media (${p => p.theme.mq.desktop}) {
    margin: 0 auto;
    max-width: ${p => p.theme.base.pageWidth};
  }
`;

export const Content = styled.main`
  display: flex;

  @media (${p => p.theme.mq.desktop}) {
    margin-bottom: 0;
  }
`;

export const Container = styled.section`
  padding: ${p => (p.mainView ? '10px' : 'auto')};
  width: ${p => (p.mainView ? '100%' : 'auto')};

  @media (${p => p.theme.mq.desktop}) {
    padding: ${p => p.theme.base.spacing.huge};
  }
`;

export const DarkOverlay = styled.div`
  background: ${p => p.theme.rgba('blackTrue', 0.5)};
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  left: 0;
  position: fixed;
  top: ${p => (p.makeSpaceForNotificationBar ? '90px' : '60px')};
  width: 100vw;
  z-index: 5000;

  ${p =>
    p.inactivatedView &&
    css`
      top: 0;
    `};
`;

export const InactivatedBox = styled.div`
  background-color: ${p => p.theme.color.whiteTrue};
  border-radius: 3px;
  text-align: center;
  padding: ${p => p.theme.spacing(10)};
  z-index: 10000;
`;



// WEBPACK FOOTER //
// ./src/components/DefaultLayout/styles.js